/* 
 * @Author: xiaowubing 
 * @Date: 2020-12-09 15:46:19 
 * @Last Modified by: xiaowubing 
 * @Last Modified time: 2020-12-09 15:46:19 
 */
import imeiInput from './index.vue';

export default imeiInput;